import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { OpalApiComponent } from '@opallabs/api'
import { linkageFromResource } from '@opallabs/json-api'
import { boardResourceFactory } from './board'
import { userResourceFactory } from './user'

type BoardUserSettingResourceV3 = OpalApiComponent<'V3', 'board_user_setting'>
export const boardUserSettingResourceFactory: Factory<BoardUserSettingResourceV3> =
  Factory.define<BoardUserSettingResourceV3>(({ afterBuild, params }) => {
    afterBuild((boardUserSetting) => {
      /**
       * Set board in afterBuild to prevent circular reference
       */
      if (!params.relationships?.board) {
        const board = boardResourceFactory.build({
          relationships: {
            board_user_setting: linkageFromResource(boardUserSetting),
          },
        })
        boardUserSetting.relationships.board = linkageFromResource(board)
      }
    })

    return {
      id: uuidV4(),
      type: 'board_user_setting',
      attributes: {
        created_at: new Date().toISOString(),
        is_starred: false,
        is_subscribed: false,
        updated_at: new Date().toISOString(),
      },
      relationships: {
        board: { data: { id: 'stubbed_until_afterBuild', type: 'board' } },
        user: linkageFromResource(userResourceFactory.build()),
      },
    } satisfies BoardUserSettingResourceV3
  })
